import 'css-chunksrc/client/common/treeToggle/controls/closeLast/styles.scss';export default {
  "closeLast": "_closeLast_1edxz_1",
  "disabled": "_disabled_1edxz_10",
  "toggleArrow": "_toggleArrow_1edxz_14"
};